/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Engine_OpenaiInputs */



/**
* | output |
* | --- |
* | "OpenAi" |
*
* @param {Spellcheck_Engine_OpenaiInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_engine_openai = /** @type {((inputs?: Spellcheck_Engine_OpenaiInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Engine_OpenaiInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("OpenAi")
	if (locale === "de") return /** @type {LocalizedString} */ ("OpenAI")
	if (locale === "it") return /** @type {LocalizedString} */ ("OpenAi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("OpenAi")
	if (locale === "es") return /** @type {LocalizedString} */ ("OpenAi")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("OpenAI")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オープンアイ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ओपनएआई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("OpenAi")
	return /** @type {LocalizedString} */ ("OpenAi")
});